import { render, staticRenderFns } from "./PurchaseAndSaleMoney.vue?vue&type=template&id=5ea3a564&scoped=true"
import script from "./PurchaseAndSaleMoney.vue?vue&type=script&lang=js"
export * from "./PurchaseAndSaleMoney.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAndSaleMoney.vue?vue&type=style&index=0&id=5ea3a564&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea3a564",
  null
  
)

export default component.exports